var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OMM_EDIT_DELIVERY_ADDRESS_ADD_ADDRESS, OMM_EDIT_DELIVERY_ADDRESS_CREATE_CART, OMM_EDIT_DELIVERY_ADDRESS_GET_CITIES_BY_ZIPCODE, OMM_EDIT_DELIVERY_ADDRESS_SUSPEND_CART, OMM_EDIT_DELIVERY_ADDRESS_UPDATE_ADDRESS, OMM_EDIT_DELIVERY_ADDRESS_VALIDATE_ADDRESS, } from '../../constants/paths';
import { FULFILLMENT_TYPE } from '../../constants/status';
import { OmmAvailableFulfillmentOptions } from '../../hooks/delivery-hooks';
import { EditDeliveryAddressAlertType, EditDeliveryAddressErrorMessages, } from '../../models/edit-delivery-address';
import { TrackErrorEventEditDeliveryAddressAnalytics } from '../../utils/edit-delivery-address/analytics';
import { getHost, getWindow } from '../../utils/general';
import { setCitiesByZip } from '../../utils/order-details/LineItemUtils';
import { apiOMM } from '../axios-client';
import { getIsZipCodeEligibilityEnabled, handleEligibility, } from '../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { convertedFulfillmentTypes } from '../../components/order-details/OrderTrackingDetails';
var baseurl = getHost();
export var SubmitValidateDeliveryAddress = function (requestData, isValidated, setSubmitCreateForm, setShowDrawerError, fulfillmentGroupIndex, setIsValidated, closeDrawer, setIsLoading, setValidationEt, validationEt, isAddressList, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        if (isValidated === false) {
            // handles continuing with Edit/Add Address when address is a non-verifiable address. It will always submit even if not recognized on second attempt
            setSubmitCreateForm(true);
            return [2 /*return*/, null];
        }
        return [2 /*return*/, apiOMM
                .post(OMM_EDIT_DELIVERY_ADDRESS_VALIDATE_ADDRESS, requestData, {
                headers: headers,
                baseURL: baseurl,
            })
                .then(function (res) {
                if (res.data.data.valid === true || isAddressList) {
                    // handles the first button click, if the address is successfully recognized
                    // if isAddressList true, then will ignore if address is valid as it is a saved address in customer account
                    setValidationEt(res.data.data.et);
                    setSubmitCreateForm(true);
                }
                else {
                    // handles Edit/Add Address if the address is not a recognized address
                    setValidationEt(res.data.data.et);
                    setIsValidated(false);
                    setIsLoading(false);
                    TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', 'n/a', EditDeliveryAddressErrorMessages.UNRECOGNIZED_ADDRESS, 'advisory');
                }
            })
                .catch(function () {
                closeDrawer();
                setShowDrawerError(fulfillmentGroupIndex);
            })];
    });
}); };
export var SubmitDeliveryAddressCreateCart = function (_a) {
    var requestData = _a.requestData, setIsChangeForm = _a.setIsChangeForm, setIsDeliveryDetails = _a.setIsDeliveryDetails, setIsLoading = _a.setIsLoading, setShowDrawerError = _a.setShowDrawerError, setExcludedShipStateApiError = _a.setExcludedShipStateApiError, setIsExcludedAddress = _a.setIsExcludedAddress, setIsValidated = _a.setIsValidated, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, fulfillmentGroup = _a.fulfillmentGroup, closeDrawer = _a.closeDrawer, setUpdatedAddressData = _a.setUpdatedAddressData, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, traceId = _a.traceId, setIsConfirmation = _a.setIsConfirmation, setIsDeliveryOptions = _a.setIsDeliveryOptions;
    return __awaiter(void 0, void 0, void 0, function () {
        var lineItems, headers;
        return __generator(this, function (_b) {
            lineItems = fulfillmentGroup.lineItems;
            headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
            if (process.env.NODE_ENV === 'development') {
                headers['true-client-ip'] = '192.168.1.19';
            }
            return [2 /*return*/, apiOMM
                    .post(OMM_EDIT_DELIVERY_ADDRESS_CREATE_CART, requestData, {
                    headers: headers,
                    baseURL: baseurl,
                })
                    .then(function (res) {
                    if (setIsDeliveryOptions) {
                        setIsDeliveryOptions(false);
                    }
                    // Check the new fulfillment type from the request, not the original
                    if (requestData.fulfillmentType === 'BODFS' && setIsConfirmation) {
                        setIsDeliveryDetails(false);
                        setIsConfirmation(true);
                        setExcludedShipStateApiError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
                        });
                    }
                    else {
                        setIsChangeForm(false);
                        setIsDeliveryDetails(true);
                    }
                    setUpdatedAddressData({ ordersInfo: res.data });
                })
                    .catch(function (err) {
                    var _a, _b;
                    var errorCode = err.response.data.errors[0].code;
                    // Excluded address (state/zip)
                    if (errorCode === '8.400.27') {
                        setIsExcludedAddress(true);
                        TrackErrorEventEditDeliveryAddressAnalytics('edit delivery address > edit form', errorCode, EditDeliveryAddressErrorMessages.EXCLUDED_ADDRESS, 'advisory');
                        if (fulfillmentGroup.fulfillmentType === FULFILLMENT_TYPE.BODFS &&
                            setIsConfirmation) {
                            setExcludedShipStateApiError(function (prev) {
                                var _a;
                                return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
                            });
                            closeDrawer();
                        }
                        return;
                    }
                    // PO generated after edit delivery address initatied - no longer eligible for delivery address change
                    if (errorCode === '8.403.2') {
                        setEditDeliveryAddressAlert({
                            alert: EditDeliveryAddressAlertType.EDIT_DELIVERY_PO_ERROR,
                            lineId: lineItems ? lineItems[0].lineId : undefined,
                        });
                        (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload(); // Grabbing updated Order Details which to reflect order no longer eiligible for delivery address change
                        return;
                    }
                    setShowDrawerError(fulfillmentGroupIndex);
                    closeDrawer();
                })
                    .finally(function () {
                    setIsValidated(true);
                    setIsLoading(false);
                })];
        });
    });
};
export var SubmitDeliveryAddressUpdateAddress = function (requestData, lineItems, setLoading, setIsSurvey, closeDrawer, setShowDrawerError, fulfillmentGroupIndex, setEditDeliveryAddressAlert, setIsAddressChangeConfirmed, setIsConfirmation, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM
                .post(OMM_EDIT_DELIVERY_ADDRESS_UPDATE_ADDRESS, requestData, {
                headers: headers,
                baseURL: baseurl,
            })
                .then(function (response) {
                setIsConfirmation(false);
                setIsSurvey(true);
                setEditDeliveryAddressAlert({
                    alert: EditDeliveryAddressAlertType.EDIT_DELIVERY_SUCCESS,
                    orderId: response.data.data.originalOrder.orderId,
                    newOrderId: response.data.data.newOrder.orderId,
                    lineId: lineItems[0].lineId,
                });
                setIsAddressChangeConfirmed(true);
            })
                .catch(function (err) {
                var _a, _b;
                var errorCode = err.response.data.errors[0].code;
                if (errorCode === '9.403.1') {
                    setEditDeliveryAddressAlert({
                        alert: EditDeliveryAddressAlertType.EDIT_DELIVERY_PO_ERROR,
                        lineId: lineItems[0].lineId,
                    });
                    (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
                    return;
                }
                setShowDrawerError(fulfillmentGroupIndex);
                closeDrawer();
            })
                .finally(function () {
                setLoading(false);
            })];
    });
}); };
export var SubmitDeliveryAddressSuspendCart = function (requestData, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM.post(OMM_EDIT_DELIVERY_ADDRESS_SUSPEND_CART, requestData, {
                headers: headers,
                baseURL: baseurl,
            })];
    });
}); };
export var SubmitDeliveryAddressGetCitiesByZipCode = function (requestData, setGetCitiesByZipCode, setIsChangeForm, setShowDrawerError, fulfillmentGroupIndex, isAuthTHDUser, fulfillmentGroup, orderDetailsData, setIsEligible, updateFormField, setIsEligibilityChecked, setIsSkeletonLoading, availableFulfillmentOptions, setFulfillmentOptionsResponse, closeDrawer, setOpen) {
    var headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, ((orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId) && {
        parentTraceId: orderDetailsData.traceId,
    }));
    if (process.env.NODE_ENV === 'development') {
        headers['true-client-ip'] = '192.168.1.19';
    }
    var isZipCodeEligibilityEnabled = getIsZipCodeEligibilityEnabled(fulfillmentGroup);
    return apiOMM
        .post(OMM_EDIT_DELIVERY_ADDRESS_GET_CITIES_BY_ZIPCODE, requestData, {
        headers: headers,
        baseURL: baseurl,
    })
        .then(function (response) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        setGetCitiesByZipCode((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.cities);
        if (requestData.zipCode) {
            setCitiesByZip(requestData.zipCode, (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.cities);
        }
        setIsChangeForm(true);
        if (setOpen) {
            setOpen(true);
        }
        if (isZipCodeEligibilityEnabled) {
            var cities = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.cities;
            if (cities && cities.length > 0) {
                var newAddressAvailableFulfillmentOptions = __assign(__assign({}, availableFulfillmentOptions), { fulfillmentAddress: __assign(__assign({}, availableFulfillmentOptions.fulfillmentAddress), { state: ((_g = cities[0]) === null || _g === void 0 ? void 0 : _g.stateCode) || '' }), newFulfillmentType: null, originalFulfillmentType: ((_h = convertedFulfillmentTypes(fulfillmentGroup.fulfillmentType)) === null || _h === void 0 ? void 0 : _h.toUpperCase()) || undefined });
                OmmAvailableFulfillmentOptions(newAddressAvailableFulfillmentOptions, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
                    .then(function (optionsResponse) {
                    setFulfillmentOptionsResponse(optionsResponse.data);
                    handleEligibility(optionsResponse.data, availableFulfillmentOptions, fulfillmentGroup, updateFormField, setIsEligible);
                    setIsEligibilityChecked(true);
                })
                    .catch(function () {
                    setShowDrawerError(fulfillmentGroupIndex);
                    closeDrawer();
                })
                    .finally(function () {
                    setIsSkeletonLoading(false);
                });
            }
            else {
                setIsEligible(false);
                setIsEligibilityChecked(true);
                setIsSkeletonLoading(false);
            }
        }
    })
        .catch(function () {
        setShowDrawerError(fulfillmentGroupIndex);
    });
};
export var SubmitAddAddress = function (requestData, traceId) { return __awaiter(void 0, void 0, void 0, function () {
    var headers;
    return __generator(this, function (_a) {
        headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (traceId && { parentTraceId: traceId }));
        if (process.env.NODE_ENV === 'development') {
            headers['true-client-ip'] = '192.168.1.19';
        }
        return [2 /*return*/, apiOMM.post(OMM_EDIT_DELIVERY_ADDRESS_ADD_ADDRESS, requestData, {
                headers: headers,
                baseURL: baseurl,
            })];
    });
}); };
